// packages/web/src/lib/breakpoints.ts
/** Widths at or below this (CSS px) are treated as "mobile" (phone) layout. */
export const MOBILE_MAX_WIDTH = 767;

/** Media query string used by useIsMobile(). Kept in sync with MOBILE_MAX_WIDTH. */
export const MOBILE_MEDIA_QUERY = `(max-width: ${String(MOBILE_MAX_WIDTH)}px)`;

/** Pure predicate: is the given viewport width in the mobile range? */
export function matchesMobile(width: number): boolean {
  return width <= MOBILE_MAX_WIDTH;
}
